export class ContractConfiguration {
    public idCountry: string;
    public contractYearTimespan: number;
    public daysBeforeExpiration: number;
}